import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import getStepFromAnalysis from 'analysis-tool/data/getStepFromAnalysis';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';
import {getChildSteps, getChildStepsForDataFrame} from 'pipelines/StepLineageUtils';

function getDownstreamStepsHelper(
  pipeline: PipelineGraphQL,
  step: GetAnalysisPipelineStep,
  steps: Set<GetAnalysisPipelineStep>,
  dataFrameId?: string
): void {
  let childSteps;
  if (dataFrameId != null) {
    childSteps = getChildStepsForDataFrame(pipeline, step, dataFrameId);
  } else {
    childSteps = getChildSteps(pipeline, step);
  }
  for (const childStep of childSteps) {
    if (!steps.has(childStep)) {
      steps.add(childStep);
      getDownstreamStepsHelper(pipeline, childStep, steps);
    }
  }
}

/**
 * Return all steps that are are downstream from the current step.
 *
 * This util is a naive traversal of the pipeline DAG that is purposefully unconcerned with ordering;
 * for traversals that accounts for branching and how we organize the pipeline into top-level tables
 * and views, see `DatasetLineageUtils`.
 *
 * Optionally takes a dataFrameId, which if specified filters the downstream steps down to the ones that
 * originate from the specified dataFrameId.
 */
export default function getDownstreamSteps(
  pipeline: PipelineGraphQL,
  stepId: string,
  dataFrameId?: string
): Set<GetAnalysisPipelineStep> {
  const downstreamSteps = new Set<GetAnalysisPipelineStep>();
  getDownstreamStepsHelper(pipeline, getStepFromAnalysis(pipeline, stepId), downstreamSteps, dataFrameId);
  return downstreamSteps;
}
